import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { name } from './symbols'
import { EditorFeatureConfigSymbol, IDataRequirementsChecker } from '@wix/thunderbolt-symbols'
import { ViewerManagerUpdateStatusApiEditorConfig, ViewerManagerUpdateStatusApiSideEffects } from './types'
import {
	IModelUpdatesHandlersImplementor,
	IViewerBatchingManager,
	ViewerBatchingManagerSymbol,
} from 'ds-feature-model-updates-invoker'
import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { createPromise } from '@wix/thunderbolt-commons'

const isNoPendingFetchRequests = (fetchRequestsStore: BeckyModel['fetchRequestsStore']) =>
	Object.values(fetchRequestsStore).filter((value) => value === null).length === 0

export const fetchRequestsDataRequirementsChecker = withDependencies(
	[named(EditorFeatureConfigSymbol, name), ViewerBatchingManagerSymbol],
	(
		editorConfig: ViewerManagerUpdateStatusApiEditorConfig,
		viewerBatchingManager: IViewerBatchingManager
	): IModelUpdatesHandlersImplementor<ViewerManagerUpdateStatusApiSideEffects> & IDataRequirementsChecker => {
		let fetchRequestsPromise: Promise<void>
		let fetchRequestsResolver: Function
		let pendingFetchPromise: Promise<void> | null = null
		let pendingFetchResolver: Function

		const blockRenderIfNeeded = (fetchRequestsStore: BeckyModel['fetchRequestsStore']) => {
			if (pendingFetchPromise) {
				if (isNoPendingFetchRequests(fetchRequestsStore)) {
					pendingFetchResolver?.()
				}
			} else if (!isNoPendingFetchRequests(fetchRequestsStore)) {
				const { resolver, promise } = createPromise()
				pendingFetchPromise = promise
				pendingFetchResolver = resolver
				viewerBatchingManager.addRenderBlockingTask(pendingFetchPromise)
			}
		}

		return {
			featureName: name,
			handlers: {
				onFetchStoreUpdated: (newFetchRequestsStore) => {
					blockRenderIfNeeded(newFetchRequestsStore)
					checkPendingRequests(newFetchRequestsStore)
				},
			},
			pendingRequirements: () => {
				const { resolver, promise } = createPromise()
				fetchRequestsPromise = promise
				fetchRequestsResolver = resolver
				checkPendingRequests(editorConfig.fetchRequestsStore)

				return fetchRequestsPromise
			},
		}

		function checkPendingRequests(fetchRequestsStore: BeckyModel['fetchRequestsStore']) {
			if (isNoPendingFetchRequests(fetchRequestsStore)) {
				return fetchRequestsResolver?.()
			}
		}
	}
)
